import {useAuth} from "../../context";
import {useEffect, useState} from "react";
import {fetchWrapper} from "../../_services/fetch";
import {config, endpoints} from "../../utils2";


const msg = "Failed with no error messages from the server."
const handleSuccess = resp => resp.success ? Promise.resolve(resp?.data) : Promise.reject({message: resp.message || msg})
const handleError = err => err?.name !== "AbortError" ? err?.error || err?.message || msg : null

const defaultValues = {
    id: null,
    name: "",
    status: false
}


export function usePaymentDetails(paymentId, defaultValue = defaultValues) {

    const {loggedIn, authToken} = useAuth()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [value, setValue] = useState(defaultValue)

    useEffect(() => {
        const controller = new AbortController()

        if (loggedIn && paymentId && paymentId !== "add") {
            setError(null)
            setLoading(true)

            // Fetch options
            const requestOptions = {
                method: "GET",
                headers: {...{Authorization: `Bearer ${authToken.jwt}`}},
                signal: controller.signal,
            }

            fetchWrapper.generic(endpoints.payment.get(paymentId), requestOptions)
                .then(handleSuccess)
                .then(setValue)
                .catch(handleError)
                .catch(setError)
                .finally(() => setLoading(false))
        } else {
            setLoading(false)
        }

        return () => {
            controller.abort()
            setLoading(false)
        }
    }, [loggedIn, paymentId])


    return {
        value,
        setValue,
        loading,
        setLoading,
        error,
        setError,
        clearError: () => setError(null)
    }
}

export function usePaymentList() {
    const {loggedIn, token} = useAuth()

    const [loadingList, setLoadingList] = useState(true)
    const [errorList, setErrorList] = useState(null)
    const [list, setList] = useState([])

    useEffect(() => {
        const controller = new AbortController()

        if (loggedIn && token) {
            setErrorList(null)
            setLoadingList(true)

            // Fetch options
            const requestOptions = {
                method: "GET",
                headers: {...{Authorization: `Bearer ${token.jwt}`}},
                signal: controller.signal,
            }

            const search = {}

            fetchWrapper.generic(endpoints.payment.list(search), requestOptions)
                .then(handleSuccess)
                .then(setList)
                .catch(err => setErrorList(handleError(err)))
                .finally(() => setLoadingList(false))
        }

        return () => {
            controller.abort()
            setLoadingList(false)
        }
    }, [loggedIn, token]);

    return {
        list,
        loadingList,
        errorList,
        clearErrorList: () => setErrorList(null)
    }
}